"use strict";
const saveAs = require("file-saver").saveAs;
const _ = require("lodash");

/**
 * File
 */
class File {
    /**
     * File Constructor
     * @param {String} name
     * @param {String} type - http://www.freeformatter.com/mime-types-list.html#mime-types-list
     * @param content
     */
    constructor(name, type = "text/plain", content = []) {
        if (_.isUndefined(name)) {
            throw new Error("File missing name parameter.");
        }
        this._name = name;
        this._type = type;
        this._content = [];
        if (content) {
            if (_.isArray(content)) {
                this.content = content;
            } else if (_.isString(content)) {
                this.setContent(content);
            }
        }
    }

    /***************************************************************/
    /* PUBLIC API
    /***************************************************************/

    /**
     * Get the name of the file
     * @returns {*}
     */
    get name() {
        return this.getName();
    }

    /**
     * Set the file name
     * @param {String} name
     * @returns {}
     */
    set name(name) {
        return this.setName(name);
    }

    /**
     * Get the name of the file
     * @returns {*}
     */
    getName() {
        return this._name;
    }

    /**
     * Set the name of the file
     * @param {String} name
     * @returns {File}
     */
    setName(name) {
        this._name = name;
        return this;
    }

    /**
     * Get the MIME Media Type of the file
     * @returns {*}
     */
    get type() {
        return this.getType();
    }

    /**
     * Set the MIME Media type
     * @param type
     * @returns {}
     */
    set type(type) {
        return this.setType(type);
    }

    /**
     * Get the MIME Media type of the file
     * @returns {string|*}
     */
    getType() {
        return this._type;
    }

    /**
     * Set the MIME Media type of the file
     * @param {String} type - http://www.freeformatter.com/mime-types-list.html#mime-types-list
     * @returns {File}
     */
    setType(type) {
        this._type = type;
        return this;
    }

    /**
     * Get the content of the file
     * @returns {Array|String}
     */
    get content() {
        return this.getContent();
    }

    /**
     * Set the content of the file
     * @param {Array|String} content
     * @returns {}
     */
    set content(content) {
        return this.setContent(content);
    }

    /**
     * get all contents
     * @returns {Array|String}
     */
    getContent() {
        return this._content;
    }

    /**
     * Set all of the content
     * @param {String|Array} contents
     * @returns {File}
     */
    setContent(content) {
        if (content) {
            if (_.isArray(content)) {
                this._content = content;
            } else if (_.isString(content)) {
                this._content = [content];
            }
        } else {
            this.clear();
        }
        return this;
    }

    /**
     * Removes the file content
     * @param content
     */
    removeContent(content) {
        _.remove(this._content, content);
        return this;
    }

    /**
     * Append content to the existing content
     * @param {String} content
     * @param {Boolean} newLine
     * @returns {File}
     */
    appendContent(content, newLine = false) {
        if (newLine) {
            content = "\r\n" + content;
        }
        this._content.push(content);
        return this;
    }

    /**
     * Prepend content to the existing content
     * @param {String} content
     * @param {Boolean} newLine
     * @returns {File}
     */
    prependContent(content, newLine = false) {
        if (newLine) {
            content = "\r\n" + content;
        }
        this._content.unshift(content);
        return this;
    }

    /**
     * Remove all content
     * @returns {File}
     */
    clear() {
        this._content = [];
        return this;
    }

    /**
     * Unlinke getContent which returns an Array of all combined content
     */
    getFileContent() {
        return this.content.join("");
    }

    /**
     * Get the file as a Blob
     * @returns {Blob}
     */
    getBlob() {
        return new Blob(this.content, {type: this.type});
    }

    /**
     * Download the file
     * @returns {File}
     */
    download() {
        if (this.name && this.content.length) {
            saveAs(this.getBlob(), this.name);
        } else {
            console.error("Unable to download file - Missing filename or contents.");
        }
        return this;
    }
}
module.exports = File;
